import StructuredCoachInfoView from './StructuredCoachInfoView';

export default StructuredCoachInfoView;
